export const multipleOwners = 'multiple-owners-for-systems';
export const aboutCard = 'about-card';
export const mermaidAdrFeatureFlag = 'mermaid-adr-feature-flag';
export const championsCardFlag = 'champions-card';
export const businessComponent = 'business-component';
export const feedbackComponent = 'feedback-component';
export const groupGuardrailCompliance = 'group-guardrail-compliance';
export const capabilities = 'capabilities';
export const userPat = 'user-pat';
export const dhDockHomepage = 'dh-dock-homepage';
export const featureFlagsObj = {
  'dh-dock-homepage': dhDockHomepage,
  'multiple-owners': multipleOwners,
  'about-card': aboutCard,
  'mermaid-adr-feature-flag': mermaidAdrFeatureFlag,
  'champions-card': championsCardFlag,
  'business-component': businessComponent,
  'feedback-component': feedbackComponent,
  'group-guardrail-compliance': groupGuardrailCompliance,
  capabilities: capabilities,
  'user-pat': userPat,
};
